import React, {useState} from 'react';
import { bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { required } from '../../util/validators';
import classNames from 'classnames';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import {intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import { findOptionsForSelectFilter } from '../../util/search';
import { propTypes } from '../../util/types';
import config from '../../config';
import { Button, FieldCheckboxGroup, Form, FieldSelect, FieldTextInput } from '../../components';
import { types as sdkTypes } from '../../util/sdkLoader';
import css from './EditListingSpecialInfoForm.module.css';

import axios from 'axios';

const sharetribeSdk = require('sharetribe-flex-sdk');
// import { indexOf } from 'core-js/core/array';

const sdk = sharetribeSdk.createInstance({
    clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID
  });

  const { UUID, LatLng } = sdkTypes;

const { Money } = sdkTypes;

const EditListingSpecialInfoFormComponent = props => {

  const [file, setFile] = useState(false);
  const [fileSend, setFileSend] = useState(false);
  const inputFileRef = React.createRef();
  const moreInfoPdf = props.currentListing.attributes.publicData.moreInfoPdf;
  const alreadySavedPdfLabel = moreInfoPdf ? moreInfoPdf.split('-')[2] : "";
  
  return(
  <FinalForm
        {...props}
        mutators={{ ...arrayMutators }}
        render={formRenderProps => {
          const {
            disabled,
            ready,
            rootClassName,
            className,
            name,
            handleSubmit,
            pristine,
            saveActionMsg,
            updated,
            updateInProgress,
            fetchErrors,
            filterConfig,
            intl
          } = formRenderProps;

          const classes = classNames(rootClassName || css.root, className);
          const submitReady = (updated && pristine) || ready;
          const submitInProgress = updateInProgress;
          const submitDisabled = disabled || submitInProgress;

          const { updateListingError, showListingsError } = fetchErrors || {};
          const errorMessage = updateListingError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingSpecialInfoForm.updateFailed" />
            </p>
          ) : null;

          const errorMessageShowListing = showListingsError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingSpecialInfoForm.showListingFailed" />
            </p>
          ) : null;

          const accessLabel = intl.formatMessage({
            id: 'EditListingAccessForm.accessLabel',
          });

          const accessPeriodLabel = intl.formatMessage({
            id: 'EditListingAccessForm.accessPeriodLabel',
          });

          const specialInfoLabelMessage = intl.formatMessage({
            id: 'EditListingPracticalInfoForm.specialInfoLabel',
          });

          const specialInfoPlaceholderMessage = intl.formatMessage({
            id: 'EditListingPracticalInfoForm.specialInfoPlaceholder',
          });


          const accessRequired = required(
            intl.formatMessage({
              id: 'EditListingAccessForm.accessRequired',
            })
          );

          //pdf upload

          const onFileChange = event => { 
            // Update the state 
            
          const infoFile = event.target.files[0];
          setFile(infoFile)
          }; 

          const handleBtnClick = () => {
            /*Collecting node-element and performing click*/
            inputFileRef.current.click();
          }


          const handleFileUpload = () => {

            //Create an object of formData 
          const formData = new FormData(); 
        
          // Update the formData object 
          formData.append( 
            "image", 
            file, 
            file.name.replace(/[^\w.]+/g, "") 
          ); 

          const listingId = typeof window !== 'undefined' ? window.location.pathname.split('/')[3] : "";
          
          return axios.post("/api/azure-upload", formData).then(resp => {
            const fileName = resp.data.fileName;

                      return sdk.ownListings.update({
                                id: new UUID(listingId),
                                publicData: {
                                      moreInfoPdf: fileName
                                    }
                            }).then(response => {
                              setFileSend(true)
                              return true
                            }).catch(error => console.log(error))
          }).catch(error => console.log(error))

    }

          return (
            <Form className={classes} onSubmit={handleSubmit}>
              {errorMessage}
              {errorMessageShowListing}



            <FieldTextInput
                id="specialInfo"
                name="specialInfo"
                className={css.policy}
                type="textarea"
                label={specialInfoLabelMessage}
                placeholder={specialInfoPlaceholderMessage}
              />


              {/* %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% */}


              <p className={css.pdfInfoLabel1}>
                   Après chaque réservation de votre place, les utilisateurs reçoivent les informations utiles à leur stationnement (numéro de place, digicode, etc) à travers un document PDF. 
                   </p>
                   
              <p className={css.pdfInfoLabel2}>
                  Ce document sera réalisé par ollo, vous pouvez donc cliquer sur suivant.
                </p>


              <div className={css.pdfUpload}>
                  <input
                  type="file"
                  id="image"
                  onChange={onFileChange} 
                  ref={inputFileRef} 
                  className={css.hiddenUploadInput}
                  />
                  <div onClick={handleBtnClick} className={ moreInfoPdf ? css.dropZoneFilled : (file ? css.dropZoneFilled :  css.dropZone)}>
                    <span className={css.dropZoneLabel}>{ moreInfoPdf && !file  ? alreadySavedPdfLabel : (file ? file.name : "Sélectionner un fichier")}</span>
                    </div>
                  <button type="button" onClick={handleFileUpload} className={ file ? css.uploadButton : css.uploadButtonDisabled}>{fileSend ? "✓" : "télécharger"}</button>
              </div>


              {/* %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% */}

            {/* <FieldSelect
              className={css.access}
              name="accessPeriod"
              id="accessPeriod"
              label={accessPeriodLabel}
              validate={accessRequired}
            >
              <option disabled value="">
                {" "}
              </option>
                <option key={"oui"} value={"oui"}>
                  {"oui"}
                </option>
                <option key={"non"} value={"non"}>
                  {"non"}
                </option>
            
            </FieldSelect> */}

<p className={css.notMandatoryWarning}>Ces informations ne sont pas obligatoires, n'hésitez pas à appuyer sur "suivant" si vous ne souhaitez pas les compléter</p>


              <Button
                className={css.submitButton}
                type="submit"
                inProgress={submitInProgress}
                disabled={submitDisabled}
                ready={submitReady}
              >
                {saveActionMsg}
              </Button>
            </Form>
          );
        }}
      />
    )};

EditListingSpecialInfoFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  fetchErrors: null,
  filterConfig: config.custom.filters,
};

EditListingSpecialInfoFormComponent.propTypes = {
  intl: intlShape.isRequired,
  rootClassName: string,
  className: string,
  name: string.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
  filterConfig: propTypes.filterConfig,
};

const EditListingSpecialInfoForm = EditListingSpecialInfoFormComponent;
export default compose(injectIntl)(EditListingSpecialInfoForm);

